const BOOKING_ID_PATTERN = /^B\d+$/

export const isBookingId = (id: string): boolean => BOOKING_ID_PATTERN.test(id)

const SHIPMENT_ID_PATTERN = /^S\d+$/
export const isShipmentId = (id: string): boolean => SHIPMENT_ID_PATTERN.test(id)
